import createLucideIcon from '../createLucideIcon';

const Reply = createLucideIcon('ReplyIcon', [
  ['polyline', { points: '9 17 4 12 9 7', key: 'hvgpf2' }],
  ['path', { d: 'M20 18v-2a4 4 0 0 0-4-4H4', key: '5vmcpk' }],
]);

export default Reply;
